export default "__VITE_ASSET__c04e1324__"